/* One comment, one column (chat makeover M3, #2718): avatar | name and time over the body | actions */
.item {
  display: flex;
  align-items: flex-start;
  gap: var(--tuna-spacing-1_5, 12px);
  padding: var(--tuna-spacing-1, 8px) 0;
  border-radius: var(--tuna-shape-borderRadius);
}

.item--highlight {
  outline: 2px dashed var(--tuna-palette-success-light);
  outline-offset: 2px;
}

/*
 * The agent's accent marks its comments (Joni §2: colour marks the agent's avatar and anchors only). AgentChat's
 * `.accentScope` sets `--agent-accent-stroke`; anywhere else it falls back to no accent.
 */
.item--assistant .body {
  border-inline-start: 2px solid var(--agent-accent-stroke, transparent);
  padding-inline-start: var(--tuna-spacing-1, 8px);
}

.avatar {
  flex: 0 0 auto;
  display: flex;
}

.main {
  flex: 1 1 auto;
  min-width: 0;
}

.meta {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1, 8px);
}

.name {
  font-weight: 600;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-primary);
}

.time {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

.body {
  margin-top: var(--tuna-spacing-0_5, 4px);
  color: var(--tuna-palette-text-primary);
}

.actions {
  flex: 0 0 auto;
}
